import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { removeAll, logout } from '../application_actions';
import { LogoutButton } from './presentational/button.jsx';
import makeBasePage from './base_page.jsx';
import { Button } from './presentational/button.jsx';

import addIconImg from '../assets/pngs/add-icon.png';
import editIconImg from '../assets/pngs/edit-icon.png';

export class MainSelection extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.removeAll();
  }

  onLogOut() {
    this.props.logout();
    const { router } = this.context.router.push('/');
  }

  render() {

    let iconStyle = {
      "height": "20px",
      "width": "20px",
      "backgroundSize": "contain",
      "backgroundRepeat": "no-repeat",
      "left": "40px"
    };

    let editIcon = Object.assign({}, iconStyle, { "backgroundImage": `url(${editIconImg})`});

    return (
      this.props.strings.MainSelection ?
       <div className="main-selection page-view-without-progress-menu" id="main-selection">
       <h1>{this.props.strings.MainSelection.title}</h1>
       <div className="options">
        <span id="registerButton">
         <Button
             text={this.props.strings.MainSelection.siteSurvey}
             onButtonClick={() => this.props.selectFlow('site_survey')}
             iconStyle={editIcon}
             id="continueToSiteSurvey"
             disabled={ !this.props.app.internetStatus }
           />
         </span>
       </div>
     </div> : <span/>
   );
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ removeAll, logout }, dispatch);
}

export default connect(null, mapDispatchToProps)(makeBasePage('MainSelection')(MainSelection));
